import { Icon } from '@/design-system/components/icons/Icon';
import { TextBody } from '@/design-system/components/typography';
import { Pressable, SxProp, useDripsyTheme, View } from 'dripsy';
import { Moment } from 'moment-timezone';
import React from 'react';
import { DatePickerSelector } from './DatePickerSelector';
import { useDatePicker } from './useDatePicker.hook';

interface DatePickerProps {
  dateProps: Moment | null;
  onValueChange: (value: Moment | null) => void;
  sx?: SxProp;
  placeholder?: string;
  options?: {
    minDate?: Moment | null;
    maxDate?: Moment | null;
    yearInputFlag?: boolean;
  };
  displayMode?: 'TOP' | 'BOTTOM';
  displayBothFlag?: boolean;
}

export const DatePicker: React.FC<DatePickerProps> = ({
  dateProps,
  onValueChange,
  sx,
  placeholder,
  options,
  displayMode = 'BOTTOM',
  displayBothFlag = true
}) => {
  const { container, wrapper } = styles;
  const { theme } = useDripsyTheme();
  const { $radius2 } = theme.space || ({} as any);
  const controller = useDatePicker({ dateProps, onValueChange });
  return (
    <View sx={wrapper}>
      <View sx={{ ...container, ...sx }}>
        <TextBody>{controller.value ? controller.value.format('YYYY-MM-DD') : placeholder ?? ' - '}</TextBody>
        <Pressable onPress={controller.toggle}>
          <Icon name="historyCalendar" />
        </Pressable>
      </View>
      <DatePickerSelector
        isOpen={controller.isOpen}
        value={controller.value}
        options={options}
        displayMode={displayMode}
        displayBothFlag={displayBothFlag}
        onValueChange={controller.onTempChange}
        onClose={controller.close}
        onConfirm={controller.onConfirmChange}
        onReset={controller.onReset}
      />
    </View>
  );
};

enum StyleName {
  wrapper = 'wrapper',
  container = 'container'
}

const styles: Record<StyleName, SxProp> = {
  wrapper: {
    zIndex: 9999
  },
  container: {
    alignItems: 'center',
    overflow: 'hidden',
    flexDirection: 'row',
    width: '100%',
    height: '$12',
    borderRadius: 5,
    borderWidth: 1,
    borderColor: '$borderButton',
    justifyContent: 'space-between',
    px: '$4'
  }
};
